const BRAIN_AREAS = {
  frontal: ["Fp1", "Fp2", "F3", "F4", "F7", "F8", "Fz"],
  central: ["C3", "C4", "Cz"],
  temporal: ["T3", "T4", "T5", "T6"],
  parietal: ["P3", "P4", "Pz"],
  occipital: ["O1", "O2"],
};

/**
 * Get the brain area for a given EEG channel.
 * @param {string} channel - The channel name (e.g., "Fp1", "C3")
 * @returns {string} - The brain area name or "unknown" for unmapped channels
 */
export const getBrainAreaFromChannel = (channel) => {
  for (const brainArea in BRAIN_AREAS) {
    if (
      BRAIN_AREAS[brainArea].some(
        (v) => v.toUpperCase() === channel.toUpperCase()
      )
    ) {
      return brainArea;
    }
  }
  // Return "unknown" for channels not in the standard mapping
  return "unknown";
};

export const getUniqueBrainAreasFromChannels = (channels) => {
  const brainAreas = new Set();

  for (const channel of channels) {
    const brainArea = getBrainAreaFromChannel(channel);

    if (brainArea) {
      brainAreas.add(brainArea);
    }
  }

  return Array.from(brainAreas);
};
